const SUBSCRIPTION = [
  [100, 500],
  [200, 900],
  [300, 1200],
  [400, 1400],
  [500, 1500],
  [1000, 2500],
  [2000, 4000],
  [3000, 4500], // DEFAULT
  [5000, 6500],
  [10000, 10000]
]

export const DEFAULT = 7
export const NOT_SET = -1

export const SUB_LENGTH = SUBSCRIPTION.length

export const getSubCountN = s => s !== -1 ? SUBSCRIPTION[s][0] : ''
export const getSubCount = s => s !== -1 ? Intl.NumberFormat().format(SUBSCRIPTION[s][0]) : ''
export const getSubTotal = s => s !== -1 ? Intl.NumberFormat().format(SUBSCRIPTION[s][1]) : ''

export const getSubLabel = s => `${getSubCount(s)} parcel - ${getSubTotal(s)} Kč`



// WEBPACK FOOTER //
// ./src/config/accountSubscription.js